export default __webpack_public_path__ + "static/media/tank_2.dd749db8.png";